// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2GlTo","buttons":"PendingPaymentAlert_buttons__9UHet"};